import { lazy } from 'react';

const AboutFAFSAModal = lazy(() =>
  import('modules/FAFSAReportingAndTracking/modals/AboutFAFSAModal'),
);

const StatusReportingModal = lazy(() =>
  import('modules/FAFSAReportingAndTracking/modals/StatusReportingModal'),
);

const TrackerVerificationModal = lazy(() =>
  import('modules/FAFSAReportingAndTracking/modals/TrackerVerificationModal'),
);

export default {
  ABOUT_FAFSA_MODAL: AboutFAFSAModal,
  STATUS_REPORTING_MODAL: StatusReportingModal,
  TRACKER_VERIFICATION_MODAL: TrackerVerificationModal,
};
